interface StatProps {
  number: string;
  suffix?: string;
  highlightFull?: boolean;
  accent?: 'saffron' | 'violet';
  label: string;
}

const stats: StatProps[] = [
  { number: '₹47K', suffix: 'Cr', label: 'spent on Indian trade shows annually' },
  { number: '80%', highlightFull: true, accent: 'saffron', label: 'of leads are never followed up' },
  { number: '3 hrs', label: 'until booth conversations become a blur' },
  // Red-team #26: soften the "12 languages" claim — say what we ship today.
  { number: '3', highlightFull: true, accent: 'violet', label: 'Indian languages live today (English, Hindi, Gujarati). Eight more by year-end.' },
];

export function Stats() {
  return (
    <section className="bg-ink-900 px-6 sm:px-8 py-16 sm:py-20 relative overflow-hidden mt-8">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-violet-500 to-saffron-500 to-transparent opacity-80" />
      <div className="absolute -top-[300px] -left-[200px] w-[700px] h-[700px] bg-[radial-gradient(circle,rgba(124,58,237,0.12),transparent_60%)] pointer-events-none" />
      <div className="absolute -bottom-[300px] -right-[200px] w-[700px] h-[700px] bg-[radial-gradient(circle,rgba(255,107,26,0.08),transparent_60%)] pointer-events-none" />

      <div className="container-mela grid grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 relative">
        {stats.map((s, i) => (
          <Stat key={i} {...s} />
        ))}
      </div>
    </section>
  );
}

function Stat({ number, suffix, highlightFull, accent, label }: StatProps) {
  return (
    <div className="text-white">
      <div className="font-display font-extrabold text-[44px] sm:text-[64px] leading-[0.95] tracking-[-0.04em] mb-3">
        {highlightFull ? (
          <span className={accent === 'violet' ? 'text-violet-400' : 'text-saffron-500'}>
            {number}
          </span>
        ) : (
          <>
            {number}
            {suffix && <span className="text-saffron-500"> {suffix}</span>}
          </>
        )}
      </div>
      <div className="text-sm text-ink-400 leading-snug max-w-[28ch]">{label}</div>
    </div>
  );
}
